window.initiateLoadMore = (ContainerSelector, ItemSelector) => {
  const loading = {
    show: () => document.querySelector('#hc-loading').style.display = 'block',
    hide: () => document.querySelector('#hc-loading').style.display = 'none',
  };
  document.querySelector('.load-more-products').addEventListener('click', e => {
    const triggerLoad = (force) => {
      
  	// document.querySelector('body').classList.contains('loading-products') ? loading.show() : loading.hide();
  	if(document.querySelector('#more-link') && !document.querySelector('body').classList.contains('loading-products')) {
     		target = document.querySelector('#more-link').getBoundingClientRect().top;
     		if(force || target < window.innerHeight + 400 ) fetchNewProducts();
  	}
    }
    triggerLoad(true);
    document.querySelector('.load-more-products').style.display = 'none';
    window.addEventListener('scroll', function(e) {
    	triggerLoad();
    });
  });
  
  const fetchNewProducts = function() {
    loading.show();
    console.log('[HC] Infinite Scroll: fetching...');
    const more = document.querySelector('#more-link');
    const url = more.getAttribute('href');
    const productsContainer = `${ContainerSelector}`; // PRODUCT CONTAINER CLASS HERE
    const productItems = `${productsContainer} > ${ItemSelector}`; // PRODUCT WRAPPER CLASS HERE
    document.querySelector('body').classList.add('loading-products');
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
      },
    })
    .then(res => res.text())
    .then(res => {
      console.log('[HC] Infinite Scroll: fetched');
      const parser = new DOMParser();
      const data = parser.parseFromString(res, "text/html");
      const newMore = data.querySelector('#more-link').getAttribute('href');
      const newProducts = data.querySelectorAll(productItems);
      document.querySelector(productsContainer).append(...newProducts);
  
      newProducts.forEach(item => {
        item.classList.add('aos-init');
        item.classList.add('aos-animate');
      })
      
      const event = new CustomEvent('newitems', { detail: { items: newProducts } });
      document.dispatchEvent(event);
      if (newMore) {
        console.log('[HC] Infinite Scroll: update `more` link');
        more.setAttribute('href', newMore)
      } else {
        document.querySelector('body').classList.remove('loading-products');
        more.remove();
      }
    })
    .catch(message => console.error(message))
    .finally(() => document.querySelector('body').classList.remove('loading-products'));
    loading.hide();
  };
}